const userinfor = {
    state: {
        // token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        ispc: false,
        clientWidth: 0,
        user: {
            islogin: false,
            member_name: "",
            member_email: "",
            total_pic: 0,
            total_vdo: 0,
            totalc: 0,
            used_space: 0,
            user_space: 0,
            ico: "",
            create_time: "",
        },
        formSettingdatas: {},
    },
    getters: {

    },
    mutations: {
        changuinfor(state, data) { //修改用户信息
            let infor = state.user;
            if (typeof(data) == "undefined") {
                for (let key in infor) {
                    infor[key] = "";
                }
                infor.islogin = false;
                // state.token = "";
            } else {
                for (let key in infor) {
                    infor[key] = data[key];
                }
                infor.islogin = true;
                // state.token = ;
            }
        },
        SET_FORM_SETTINGDATAS(state, data) {
            state.formSettingdatas = data
        }
    },
    actions: {

    },
    module: {

    }
}
export default userinfor;


// WEBPACK FOOTER //
// ./src/store/user.js